import { Switch } from '@headlessui/react';
import classNames from 'classnames';

export interface ToggleProps {
  enabled: boolean;
  title: string;
  disabled?: boolean;
  description?: string;
  onChange: (check: boolean) => void;
  variant?: 'blue' | 'black';
}

export const Toggle = ({
  enabled,
  onChange,
  title,
  disabled,
  description,
  variant = 'black',
}: ToggleProps) => {
  return (
    <Switch.Group>
      <div className="flex items-center">
        <Switch
          checked={enabled}
          onChange={onChange}
          disabled={disabled}
          className={classNames(
            {
              'bg-[#171717]': enabled && variant === 'black',
              'bg-[#1677ff]': enabled && variant === 'blue',
              'bg-gray-300': !enabled,
              '!opacity-50': disabled,
            },
            'relative inline-flex h-6 w-11 items-center rounded-full hover:opacity-80',
          )}
        >
          <span
            className={`${
              enabled ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition`}
          />
        </Switch>
        <div className="flex flex-col gap-0.5">
          <Switch.Label className={classNames('ml-4', { 'cursor-pointer': !disabled })}>
            {title}
          </Switch.Label>
          <span className="text-neutral-500 ml-4 text-[12px]">{description}</span>
        </div>
      </div>
    </Switch.Group>
  );
};
